<template>
	<scroll-view class="userlist-scroll-view" scroll-y="true" >
		<view class="userlist-scroll">
			<view class="userlist-item" v-for="uData in myUserList" :key="uData.id">{{uData.f_name}}</view>
		</view>
	</scroll-view>
</template>

<script>
	export default {
		computed: {
			myUserList() {
				return this.$store.state.myUserList;
			}
		},
		mounted() {
			setTimeout(function() {
				// console.error(this.myUserList)
			}.bind(this), 20)
		},
		methods: {
			
		}
	}
</script>

<style>
</style>
